import { createApp } from 'vue'
import { Modal } from 'bootstrap'
import swal from 'sweetalert'

const app = createApp({
  data() {
    return {
      isSendingEmail: false,
      signUpComplete: false,
      formData: {
        firstName: null,
        lastName: null,
        email: null,
      },
    }
  },
  methods: {
    async sendEmail() {
      this.isSendingEmail = true

      try {
        const route = document.querySelector('#modal-email-signup form').getAttribute('action')

        const resp = await axios.post(route, this.formData)

        let div = document.createElement('div')
        div.innerHTML = `<div class="alert alert-success text-start">Thank you, your newsletter sign-up was successful.</div>`
        swal({
          content: div
        })

        this.isSendingEmail = false
        this.signUpComplete = true
        this.closeModal()

      } catch (error) {
        console.error(error)
        this.isSendingEmail = false

        if (error.response.data.errors) {
          let errors = []
          for (let e in error.response.data.errors) {
            errors.push(error.response.data.errors[e][0])
          }

          let div = document.createElement('div');
          div.innerHTML = '<ul class="alert alert-danger text-start"><li>' + errors.join('</li><li>') + '</li></ul>'
          swal({
            icon: 'error',
            content: div
          })
        } else {
          swal('An unexpected error occurred.')
        }
      }
    },
    closeModal() {
      const modal = Modal.getOrCreateInstance('#modal-email-signup')
      modal.hide()
    },
  }
})

app.mount('#modal-email-signup')
